export const notificacions = (state) => state.notificacions
export const notificacions_count = (state) => state.notificacions_count
export const notificacions_news = (state) => state.notificacions_news
export const notification = (state) => state.notification
